// extracted by mini-css-extract-plugin
export default {"eventDetailsCard":"TagHeading_eventDetailsCard__u12Z3","featuredItemCard":"TagHeading_featuredItemCard__bISrS","donationLabel":"TagHeading_donationLabel__E6Vrl"};